module.exports = __webpack_public_path__ + "static/media/dorp.08643667.jpg";